import { environment } from "../../../environments/environment";

//env
export const apiUrl = environment.apiBase+'/'+environment.apiVersion;
export const xapiKey = environment.xApiToken;
export const apiVersion = environment.apiVersion;

//values
export const UserType = 'hospital';
export const LandingPageTitle = 'Teleconsult';


//contents
export const HomeTitle = '';
export const HomeSubmsg = '';


//URLS
export const ForgotPasswordLink = '/auth/forgotpassword';
export const FactorVerificationLink = '/auth/factorverification';
export const LoginLink = 'auth/login';
export const DashboardLink = environment.apiVersion+'/teleconsult';
export const Signuplink = '/auth/signup';

//Pagination
export const PageSize = '10';
export const PageSizeOptions = ['10', '20'];

//Date Formats

export const MyDate_Formats = {
	parse: {
		dateInput: 'MM/YYYY',
	},
	display: {
		//   dateInput: CustomDateFormatPipe,
		dateInput: "DD-MMM-YYYY",
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

//slots
export const TimeSlots = false;
export const QueueSlots = true;
export const AdvancedSlots = true;

//Teleconsult
export const TeleconsultProviderLink = environment.teleconsultLinks.provider;
export const TeleconsultPatientLink = environment.teleconsultLinks.client;
